import { roundNumber } from '@local_modules/generic/round-number.js'
// import { valueMaker } from './value-maker.js'
import { computeCell } from '../../../data/compute/compute-cell/index.js'

export function valuePinnedMaker (cellParams, context) {
  // console.log('valuePinnedMaker', cellParams)
  let totalValue = 0

  cellParams.api.forEachNodeAfterFilterAndSort(function (rowNode) {
    // console.group('rowNode')
    // console.log('rowNode', rowNode)

    // const targetMonth = cellParams.colDef.context?.month
    // const cellValue = valueMaker(rowNode.data, targetMonth, context)

    const cellValue = computeCell({
      data: rowNode.data,
      context: cellParams.context,
      colDef: cellParams.colDef,
      z_isInPinnedRow: 'yes_but_dont_show_debug'
    })
    totalValue += cellValue

    // console.log('cellValue', cellValue, ' => totalValue', totalValue)
    // console.groupEnd()
  })

  totalValue = roundNumber(totalValue, 4)

  return totalValue
}
